"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicTag = void 0;
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../typography");
var styles_1 = require("./styles");
var TEXT = {
    CODE: 'Code',
    DESIGN: 'Design',
    WORKING: 'Working',
    PROJECT_MANAGEMENT: 'Project Management',
};
var CONFIG = {
    CODE: {
        color: 'BLUE_50',
        hoverColor: 'BLUE_50',
        shape: 'rectangle',
    },
    DESIGN: {
        color: 'GREEN_50',
        hoverColor: 'GREEN_60',
        shape: 'bullet-right',
    },
    WORKING: {
        color: 'RED_50',
        hoverColor: 'RED_60',
        shape: 'pill',
    },
    PROJECT_MANAGEMENT: {
        color: 'YELLOW_50',
        hoverColor: 'YELLOW_60',
        shape: 'bullet-left',
    },
};
var TopicTag = function (_a) {
    var href = _a.href, topic = _a.topic, children = _a.children, commonProps = __rest(_a, ["href", "topic", "children"]);
    var content = (react_1.default.createElement(typography_1.Label, { level: "2", inline: true }, children || TEXT[topic]));
    if (href) {
        return (react_1.default.createElement(styles_1.WrapperLink, __assign({ "data-component-name": "TopicTag" }, commonProps, { href: href, "$borderColor": CONFIG[topic].color, color: "GREY_90", hoverColor: CONFIG[topic].hoverColor, "$shape": CONFIG[topic].shape }), content));
    }
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "TopicTag" }, commonProps, { "$borderColor": CONFIG[topic].color, color: "GREY_90", "$shape": CONFIG[topic].shape }), content));
};
exports.TopicTag = TopicTag;
exports.default = exports.TopicTag;
